import { jsx, css } from '@emotion/react';
import _ from 'lodash';

import Section from './oc-section';
import { connectLocation } from '../../location/LocationConnectors';
import Accordion from '../oc-document-type-accordion';
import FeaturedDocument from '../oc-featured-document';
import RichText from '../oc-rich-text';
import getExtension from '../utilities/file-extension';

const sectionStyles = css`
  > * {
    width: 80%;
    margin-left: 10%;
    margin-right: 10%;

    @media (max-width: 767px) {
      width: 100%;
      margin-left: 0;
      margin-right: 0;
    }
  }
`;

const featuredDocuments = css`
  display: flex;
  flex-direction: row;

  .oc-media-object {
    width: 45%;

    &:nth-of-type(1) {
      margin-right: 5%;
    }

    &:nth-of-type(2) {
      margin-left: 5%;
    }

    > a {
      height: 130px;
      width: 100px;
      overflow: hidden;

      img {
        height: 130px;
        max-width: initial;
        width: auto;
      }
    }
  }
  @media (max-width: 1199px) {
    flex-direction: column;

    > .oc-media-object {
      width: 100%;
      margin-left: 0 !important;
      margin-right: 0 !important;
    }
  }
`;

const SpecificationsAndLiterature = connectLocation(
  ({ heading, anchor, types = {}, featured = [], documents, className }) => (
    <Section anchor={anchor} css={sectionStyles} className={className}>
      <h2>
        <RichText content={heading} />
      </h2>
      <div css={featuredDocuments}>
        {featured
          .filter(doc => doc)
          .map(
            ({
              value: vanityTitle,
              title,
              source,
              url,
              description,
              category,
              size_bytes,
              publication_id,
              id,
              thumb = {},
            }) => (
              <FeaturedDocument
                key={publication_id || id}
                title={vanityTitle || title}
                description={description}
                url={source == 'dms2' ? `https://www.owenscorning.com/dms/${encodeURIComponent(publication_id)}` : url}
                category={category}
                extension={getExtension(url)}
                sizeBytes={size_bytes}
                thumbUrl={thumb.url}
                pubId={publication_id}
              />
            )
          )}
      </div>
      <Accordion groups={types} items={documents} />
    </Section>
  )
);

SpecificationsAndLiterature.WrappedComponent.displayName = 'SpecificationsAndLiterature';

export default SpecificationsAndLiterature;
